<template>
  <div class="lotlogPage">
    <b-modal size="lg" ref="lotlog-modal"
      :title="(inModifyMode ? 'Modifica' : 'Crea') + ' lotto'"
      :ok-title="inModifyMode ? 'Modifica' : 'Crea'"
      @close="onChangeLotLog(null)"
      @ok="onOkLotLog">
      <lot-log-details :lotlog="selectedLotLog" />
    </b-modal>

    <div class="clearfix">
      <div class="float-left">
        <button class="btn btn-primary" @click="newLotLog">Nuovo lotto <i class="fa fa-plus"></i></button>
      </div>
    </div>
    <lot-log-list @lotlogChanged="onChangeLotLog" :list="lotLogList" />
  </div>
</template>

<script>
import LotLogList from "@/components/lotlog/LotLogList.vue";
import LotLogDetails from "@/components/lotlog/LotLogDetails.vue";
import { mapState } from "vuex";
import lotlogService from "../services/lotlog";

export default {
  name: "LotLogView",
  data() {
    return {
      selectedLotLog: null
    };
  },
  mounted() {
    this.$store.dispatch("lotLogModule/loadLotLogs");
  },
  computed: {
    ...mapState("lotLogModule", {
      lotLogList: function(state) {
        return state.lotLogList;
      }
    }),
    inModifyMode() {
      return !!(this.selectedLotLog && this.selectedLotLog._id)
    }
  },
  methods: {
    async onOkLotLog() {
      if (!this.selectedLotLog) return;
      if (this.selectedLotLog._id) {
        await lotlogService.updateLotLog(this.selectedLotLog)
      } else {
        await lotlogService.createLotLog(this.selectedLotLog)
      }
      this.$store.dispatch("lotLogModule/loadLotLogs")
    },
    onChangeLotLog(lotlog) {
      if (lotlog) {
        const parsed = JSON.parse(JSON.stringify(lotlog));
        if (typeof parsed.desiredAlcohol === 'undefined') {
          parsed.desiredAlcohol = null;
        }
        if (typeof parsed.desiredReadyDate === 'undefined') {
          parsed.desiredReadyDate = null;
        }
        if (typeof parsed.alcholTollerance === 'undefined' || parsed.alcholTollerance === null) {
          parsed.alcholTollerance = 0.5;
        }
        this.selectedLotLog = parsed;
        this.$refs['lotlog-modal'].show()
      } else {
        this.selectedLotLog = null;
        this.$refs['lotlog-modal'].hide()
      }
    },
    newLotLog() {
      this.onChangeLotLog({
        lotCode: "",
        product: "",
        startDate: new Date(),
        endDate: null,
        estimatedEndDate: null,
        status: "OPEN",
        desiredAlcohol: null,
        desiredReadyDate: null,
        alcholTollerance: 0.5,
        data: [],
        user: ""
      });
    }
  },
  components: {
    LotLogList,
    LotLogDetails
  }
};
</script>
